<template>
  <div class="content">
    <!-- 筛选查询框 -->
    <el-form :inline="true" size="mini">
      <el-form-item>
        <el-button type="primary" @click="addSkuDialog">创建卡券</el-button>
      </el-form-item>
      <el-form-item>
        <el-button
          :loading="downloadLoading"
          style="margin: 0 0 10px 0px"
          type="primary"
          icon="el-icon-document"
          @click="handleDownload"
          >导出 Excel（数量/ {{ dataList.length }}条）</el-button
        >
      </el-form-item>
      <el-form-item label="卡券名称: " style="margin-left:20px">
        <el-input
          v-model="selectForm.name"
          placeholder="请输入"
          style="width:180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="卡号: " style="margin-left:20px">
        <el-input
          v-model="selectForm.vipNumber"
          placeholder="请输入"
          style="width:180px"
          clearable
        ></el-input>
      </el-form-item>
      <el-form-item label="手机号: " style="margin-left:20px">
        <el-input
          v-model="selectForm.userPhone"
          placeholder="请输入"
          style="width:180px"
          clearable
        ></el-input>
      </el-form-item>
      <!-- <el-form-item label="收货地址: " style="margin-left:20px">
        <el-input
          v-model="selectForm.adressDes"
          placeholder="请输入"
          style="width:180px"
          clearable
        ></el-input>
      </el-form-item> -->
      <el-form-item label="核销状态: " style="margin:0 20px">
        <el-select
          style="width:180px"
          v-model="selectForm.cardStatus"
          placeholder="请选择"
          clearable
        >
          <div v-for="(item, index) in hexiaoStatus" :key="index">
            <el-option :label="item.value" :value="item.id"></el-option>
          </div>
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button type="primary" @click="selectAllBtn">搜索</el-button>
      </el-form-item>
    </el-form>

    <!-- 商品表格 -->
    <div style="height:70%">
      <el-table
        border
        :data="dataList"
        style="width: 100%"
        height="100%"
        v-loading="loading"
        element-loading-spinner="el-icon-loading"
        element-loading-text="正在加载中"
      >
        <el-table-column
          type="index"
          label="序号"
          width="50"
          align="center"
        ></el-table-column>

        <el-table-column label="卡券名称" min-width="180" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.name ? scope.row.name : "暂无" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="卡券内容" min-width="200" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.msg ? scope.row.msg : "/" }}</span>
          </template>
        </el-table-column>
        <el-table-column label="卡号" width="150" align="center">
          <template slot-scope="scope">
            <span>{{ scope.row.vipNumber }}</span>
          </template>
        </el-table-column>
        <el-table-column label="核销状态" width="100" align="center">
          <template slot-scope="scope">
            <el-tag type="danger" v-if="scope.row.cardStatus === 0"
              >未领取</el-tag
            >
            <el-tag type="danger" v-else-if="scope.row.cardStatus === 1"
              >未核销</el-tag
            >
            <el-tag type="success" v-else>已核销</el-tag>
          </template>
        </el-table-column>
        <!-- <el-table-column label="核销时间" min-width="200" align="center">
          <template slot-scope="scope">
            <span>{{
              scope.row.writeOffTime ? scope.row.writeOffTime : "/"
            }}</span>
          </template>
        </el-table-column> -->

        <el-table-column label="操作" width="240" align="center">
          <template slot-scope="scope">
            <el-button
              size="mini"
              @click="ejectaddCardCouponGoods(scope.row)"
              class="handleBtn"
              type="primary"
              >详情</el-button
            >
            <el-button
              size="mini"
              @click="ejectFahuo(scope.row)"
              class="handleBtn"
              type="success"
              v-if="scope.row.cardStatus === 1 || scope.row.cardStatus === 2"
              >{{ scope.row.logisticsNumber ? "已发货" : "发货" }}</el-button
            >
            <el-button
              size="mini"
              type="danger"
              @click="deleteCardCouponGoods(scope.row)"
              :disabled="role_id == 1"
              class="handleBtn"
              >删除</el-button
            >
          </template>
        </el-table-column>
      </el-table>
      <el-pagination
        @size-change="handleSizeChange"
        @current-change="currentChange"
        :page-sizes="[50, 100, 500, 1000, 2000]"
        :page-size="50"
        layout="total, sizes, prev, pager, next, jumper"
        :current-page="selectForm.pageSize"
        :total="totalCount"
      >
      </el-pagination>
    </div>

    <!-- 核销表单 -->
    <el-dialog
      :title="inpitTypeName"
      :visible.sync="dialogFormVisible"
      :close-on-click-modal="false"
    >
      <div style="max-height:400px; overflow-y: auto;">
        <el-form :model="form" label-width="100px">
          <el-form-item label="核销状态:">
            <el-select
              v-model="form.cardStatus"
              placeholder="请选择核销状态"
              disabled
            >
              <div v-for="item in hexiaoStatus" :key="item.id">
                <el-option :label="item.value" :value="item.id"></el-option>
              </div>
            </el-select>
          </el-form-item>
          <el-form-item label="核人手机号" v-if="form.cardStatus == 2">
            <el-input v-model="form.writeOffPhone" disabled></el-input>
          </el-form-item>
          <el-form-item label="卡券核销时间" v-if="form.cardStatus == 2">
            <el-input v-model="form.writeOffTime" disabled></el-input>
          </el-form-item>
          <el-form-item label="卡券名称">
            <el-input
              v-model="form.name"
              auto-complete="off"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="卡券内容">
            <el-input
              disabled
              v-model="form.msg"
              auto-complete="off"
              type="textarea"
            ></el-input>
          </el-form-item>
          <el-form-item label="卡号">
            <el-input
              v-model="form.vipNumber"
              auto-complete="off"
              disabled
            ></el-input>
          </el-form-item>
          <!-- <el-form-item label="领取人姓名">
            <el-input v-model="form.userName" auto-complete="off"></el-input>
          </el-form-item> -->
          <el-form-item label="所属人手机号">
            <el-input
              v-model="form.userPhone"
              auto-complete="off"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="创建人手机号">
            <el-input
              v-model="form.createUserPhone"
              auto-complete="off"
              disabled
            ></el-input>
          </el-form-item>
          <el-form-item label="创建时间">
            <el-input
              v-model="form.createTime"
              auto-complete="off"
              disabled
            ></el-input>
          </el-form-item>

          <!-- <el-form-item label="邮寄地区">
          <el-input
            v-model="form.adress"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="邮寄详细地址">
          <el-input
            v-model="form.adressDes"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item> -->
        </el-form>
      </div>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">返 回</el-button>
        <!-- <el-button type="primary" @click="updataBtn">修 改</el-button> -->
      </div>
    </el-dialog>

    <!-- 发货表单 -->
    <el-dialog
      title="发货(后台核销卡券)"
      :visible.sync="dialogFormVisible2"
      :close-on-click-modal="false"
    >
      <el-form :model="form" label-width="200px">
        <el-form-item label="卡券名称">
          <el-input v-model="form.name" auto-complete="off" disabled></el-input>
        </el-form-item>
        <el-form-item label="卡券内容">
          <el-input
            disabled
            v-model="form.msg"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>
        <el-form-item label="所属人手机号">
          <el-input
            v-model="form.userPhone"
            auto-complete="off"
            disabled
          ></el-input>
        </el-form-item>

        <el-form-item label="邮寄详细地址">
          <el-input
            v-model="form.adressDes"
            auto-complete="off"
            type="textarea"
          ></el-input>
        </el-form-item>

        <el-form-item label="物流单号(线上邮寄时填写)">
          <el-input
            v-model="form.logisticsNumber"
            auto-complete="off"
          ></el-input>
        </el-form-item>
      </el-form>

      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible2 = false">取 消</el-button>
        <el-button type="primary" @click="updataBtn">确 定</el-button>
      </div>
    </el-dialog>

    <!-- 创建卡券弹窗 -->
    <el-dialog title="创建卡券" :visible.sync="couponVisible">
      <!-- <div style="margin:20px;color:red">
        生成规则:
        XXXX(前四位自己输入)+XXXX(随机生成)+XXXX(设置一个数字起点,按数递增)
      </div> -->
      <el-form :model="skuForm" label-width="120px">
        <el-form-item label="卡券名称" required>
          <el-input
            v-model="addCouponForm.name"
            auto-complete="off"
            placeholder="请输入"
            maxlength="10"
          ></el-input>
        </el-form-item>
        <el-form-item label="卡券内容" required>
          <el-input
            v-model="addCouponForm.msg"
            auto-complete="off"
            placeholder="请输入"
            type="textarea"
          ></el-input>
        </el-form-item>

        <!-- <el-form-item label="选择关联商品: " required>
          <el-select
            v-model="addCouponForm.msg"
            multiple
            filterable
            placeholder="请输入关键词搜索商品"
            style="width: 100%;"
          >
            <el-option
              v-for="item in goodsArr"
              :key="item.id"
              :label="item.productName"
              :value="item.id"
            >
            </el-option>
          </el-select>
        </el-form-item> -->

        <el-form-item label="所属人手机号" required>
          <el-input
            v-model="addCouponForm.userPhone"
            auto-complete="off"
            type="number"
          ></el-input>
        </el-form-item>
        <!-- <el-form-item label="核销状态:">
          <el-select v-model="form.cardStatus" placeholder="请选择核销状态">
            <div v-for="item in hexiaoStatus+''" :key="item.id">
              <el-option :label="item.value" :value="item.id"></el-option>
            </div>
          </el-select>
        </el-form-item> -->
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="couponVisible = false">取 消</el-button>
        <el-button type="primary" @click="addCouponBtn">确 定</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
import {
  addCardCouponGoods,
  updateCardCouponGoods,
  selectCardCouponGoods,
  deleteCardCouponGoods,
} from "@/services/cardCouponGoods.js";
export default {
  created() {
    this.role_id = this.$store.state.supUser.role_id;
    this.selectAll();
  },
  data() {
    return {
      goodsArr: [],
      role_id: "",
      sum1: "",
      sum2: "",
      selectForm: {
        msg: "",
        vipNumber: "",
        userPhone: "",
        cardStatus: "",
        adressDes: "",
        jihuoStatus: "",
        pageSize: 1,
        pageNumber: 50,
      }, //筛选条件
      totalCount: 0,
      downloadLoading: false,
      addCouponForm: {}, //新增卡券参数
      status: 0,
      goodsTitle: "",
      tableData: [],
      categoryId: "",
      productName: "",
      // 一级分类 二级分类 商品
      select_one_id: "",
      select_two_id: "",
      hexiaoStatus: [
        { id: 0, value: "未领取" },
        { id: 1, value: "未核销" },
        { id: 2, value: "已核销" },
      ],
      fahuoStatus: [
        { id: 0, value: "未发货" },
        { id: 1, value: "已发货" },
      ],
      jihuoStatus: [
        { id: 0, value: "未激活" },
        { id: 1, value: "已激活" },
      ],
      dataList: [],
      dialogFormVisible: false,
      dialogFormVisible2: false,
      formLabelWidth: "120px",
      fileList: [],
      loading: false,
      form: {},
      inpitTypeName: "",
      headerImg: [],
      detailsImg: [],
      sku: [], //sku数组
      skuActive: "",
      skuForm: {
        //新增sku
        productId: "",
        price: "",
        sku: "",
      },
      couponVisible: false,
    };
  },
  methods: {
    selectAll() {
      this.loading = true;
      selectCardCouponGoods({ ...this.selectForm })
        .then((resp) => {
          console.log(resp);
          if (resp.code === 200) {
            setTimeout(() => {
              this.loading = false;
            }, 600);
            this.dataList = resp.rows;
            this.totalCount = resp.total;
          } else {
            setTimeout(() => {
              this.loading = false;
            }, 600);
            this.$message.error("网络错误,请稍后重试!");
          }
        })
        .catch((err) => {
          console.log(err);
          this.$message.error("服务器异常,请联系技术人员!");
        });
    },
    selectAllBtn() {
      this.selectForm.pageSize = 1;
      this.selectAll();
    },
    // 切换每页数量
    handleSizeChange(e) {
      console.log(e);
      this.selectForm.pageNumber = e;
      this.selectForm.pageSize = 1;
      this.selectAll();
    },
    // 分页页码
    currentChange(e) {
      console.log(e);
      this.selectForm.pageSize = e;
      this.selectAll();
    },
    /* 新增 */
    addSkuDialog() {
      if (this.totalCount >= 50000) {
        return this.$message.error("当前数据已达上限,服务器资源错误");
      }
      this.couponVisible = true;
      this.addCouponForm = {};
    },
    addCouponBtn() {
      if (
        !this.addCouponForm.name ||
        !this.addCouponForm.userPhone ||
        !this.addCouponForm.msg
      ) {
        return this.$message.error("选项不能为空");
      }
      console.log("addCouponForm", this.addCouponForm);
      addCardCouponGoods({
        ...this.addCouponForm,
        createUserPhone: this.$store.state.supUser.supplier_phone,
        givePhone: this.$store.state.supUser.supplier_phone,
      }).then((resp) => {
        console.log(resp);
        if (resp.code == 200) {
          this.$message.success("新增成功");
          this.couponVisible = false;
          this.selectAll();
        } else {
          this.$message.error("新增失败");
        }
      });
    },

    /* 修改 */
    ejectaddCardCouponGoods(row) {
      this.dialogFormVisible = true;
      this.inpitTypeName = "卡券详情";
      this.form = JSON.parse(JSON.stringify(row));
    },
    ejectFahuo(row) {
      this.dialogFormVisible2 = true;
      this.form = JSON.parse(JSON.stringify(row));
    },

    updataBtn() {
      console.log("form", this.form);
      updateCardCouponGoods({
        ...this.form,
        writeOffPhone: this.$store.state.supUser.supplier_phone,
        cardStatus: 2,
      }).then((resp) => {
        console.log(resp);
        if (resp.code == 200) {
          this.$message.success("操作成功");
          this.dialogFormVisible = false;
          this.dialogFormVisible2 = false;
          this.selectAll();
        } else {
          this.$message.error("操作失败");
        }
      });
    },

    /* 删除 */
    deleteCardCouponGoods(row) {
      console.log("删除===", row);
      this.$confirm("此操作将永久删除该卡券, 是否继续?", "提示", {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      })
        .then(() => {
          deleteCardCouponGoods(row).then((resp) => {
            console.log(resp);
            this.$message({
              type: "success",
              message: "删除成功!",
            });
            this.selectAll();
          });
        })
        .catch(() => {
          this.$message({
            type: "info",
            message: "已取消删除",
          });
        });
    },
    // 导出数据
    handleDownload() {
      this.downloadLoading = true;
      import("../../vendor/Export2Excel").then((excel) => {
        const tHeader = [
          "id",
          "卡券名称",
          "卡券内容",
          "卡号",
          "领取人手机号",
          "核销状态(0未领取,1未核销,2已核销))",
          "创建时间",
        ];
        const filterVal = [
          "id",
          "msg",
          "vipNumber",
          "userPhone",
          "cardStatus",
          "createTime",
        ];
        const list = this.dataList;
        const data = this.formatJson(filterVal, list);
        excel.export_json_to_excel({
          header: tHeader,
          data,
          filename: "商品卡券列表下载",
          autoWidth: true, //Optional
          bookType: "xlsx", //Optional
        });
        setTimeout(() => {
          this.downloadLoading = false;
        }, 2000);
      });
    },
    formatJson(filterVal, jsonData) {
      return jsonData.map((v) =>
        filterVal.map((j) => {
          return v[j];
        })
      );
    },
  },
};
</script>

<style scoped>
.content {
  margin: 30px auto;
  /* border:1px solid red; */
  width: 80%;
}
.el-pagination {
  text-align: center;
  margin: 20px;
}
.goodsTitle:hover {
  cursor: pointer;
}
.upload-demo {
  margin: 20px;
}
.sku {
  border: 1px dotted rgb(189, 189, 189);
  padding: 10px;
  display: flex;
  flex-wrap: wrap;
  margin: 10px 0;
}
.sku > div {
  margin-right: 10px;
  padding: 10px 20px;
  background: rgb(245, 138, 44);
  border-radius: 10px;
  color: white;
}
.sku > div:hover {
  cursor: pointer;
}
.skuBg {
  background: rgb(254, 66, 3) !important;
}
.handleBtn {
  margin: 5px;
}
</style>
